import { TimestampFilter } from "TimestampFilter";

export function toSql(columnName: string, filter: TimestampFilter): string {
  const lowerBound: string = new Date(filter.lowerBoundTimestamp).toISOString();
  const upperBound: string = new Date(filter.upperBoundTimestamp).toISOString();
  return `${columnName} >= parseDateTime64BestEffort('${lowerBound}') AND ${columnName} <= parseDateTime64BestEffort('${upperBound}')`;
}
